import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import './lib/i18n'
import { ErrorBoundary } from './components/common/ErrorBoundary'

ReactDOM.createRoot(document.getElementById('root')!).render(
 <React.StrictMode>
 <ErrorBoundary>
 <BrowserRouter>
 <App />
 </BrowserRouter>
 </ErrorBoundary>
 </React.StrictMode>,
)